module.exports = __webpack_public_path__ + "static/media/digitalBanner.318b7985.png";